//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "EmptyNoteCard",
  components: {
    Divider: () => import("@/components/common/Divider"),
  },
  computed: {
    ...mapGetters({
      width: "viewport/width",
    }),
  },
  watch: {
    width() {
      this.$emit('set-wrapper-width', this.$refs['empty-note-card']?.clientWidth)
      this.$emit('set-item-width', this.$refs['empty-note-card']?.clientWidth)
    }
  },
  mounted() {
    this.$emit('set-wrapper-width', this.$refs['empty-note-card']?.clientWidth)
    this.$emit('set-item-width', this.$refs['empty-note-card']?.clientWidth)
  }
};
